class Plans_Slide {
    static instance;

    static getInstance() {
        if (!Plans_Slide.instance) {
            Plans_Slide.instance = new Plans_Slide();
        }
        return Plans_Slide.instance;
    }

    constructor() {
        $(window).on('elementor/frontend/init', () => {
            this.init();
        });
    }

    init() {
        elementorFrontend.hooks.addAction('frontend/element_ready/opal-plans-slide.default', ($scope) => {
            var $count = $scope.find('.animated-number');
            var $lineWidth = $scope.find('.line-width');
            var $lineHeight = $scope.find('.line-height');

            $count.prop('Counter', 0).animate({
                Counter: $count.text()
            }, {
                duration: 4000,
                easing: 'swing',
                step: function (now) {
                    $(this).text(Math.ceil(now));
                }
            });

            $lineWidth.prop('Counter', 0).animate({
                Counter: $lineWidth.data('width')
            }, {
                duration: 4000,
                easing: 'swing',
                step: function (now) {
                    $(this).css({
                        width: Math.ceil(now) + '%'
                    });
                }
            });

            $lineHeight.prop('Counter', 0).animate({
                Counter: $lineHeight.data('height')
            }, {
                duration: 4000,
                easing: 'swing',
                step: function (now) {
                    $(this).css({
                        height: Math.ceil(now) + '%'
                    });
                }
            });

        });
    }
}

Plans_Slide.getInstance();